function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.865744 0.646039C0.914383 0.599476 0.972163 0.562533 1.03578 0.537327C1.09939 0.51212 1.16759 0.499146 1.23646 0.499146C1.30533 0.499146 1.37353 0.51212 1.43714 0.537327C1.50076 0.562533 1.55854 0.599476 1.60717 0.646039L7.89049 6.64604C7.93925 6.69248 7.97794 6.74766 8.00433 6.80841C8.03073 6.86915 8.04432 6.93427 8.04432 7.00004C8.04432 7.06581 8.03073 7.13093 8.00433 7.19167C7.97794 7.25242 7.93925 7.30759 7.89049 7.35404L1.60717 13.354C1.50886 13.4479 1.3755 13.5007 1.23646 13.5007C1.09741 13.5007 0.964064 13.4479 0.865744 13.354C0.767424 13.2602 0.712188 13.1328 0.712188 13C0.712188 12.8673 0.767424 12.7399 0.865744 12.646L6.77939 7.00004L0.865744 1.35404C0.816982 1.30759 0.778294 1.25242 0.751898 1.19167C0.725501 1.13093 0.711914 1.06581 0.711914 1.00004C0.711914 0.934272 0.725501 0.869151 0.751898 0.808406C0.778294 0.747661 0.816982 0.692485 0.865744 0.646039Z",
  fill: "#23335B"
});

var SvgSeparator = function SvgSeparator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeparator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/separator.f77202e4.svg";
export { ForwardRef as ReactComponent };